import { Modal, Typography } from 'antd';
import React from 'react';
import { Attribute, ModalConfirmProps } from 'types';
import ManageAttribute from '../ManageProduct/ManageAttribute/ManageAttribute';
import { imageEmpty } from 'utils/importFile';
import { ButtonCommon } from '../Button/ButtonCommon';
import HeaderContent from '../HeaderContent/HeaderContent';

import { formatCurrency, getFilePath } from 'utils';
import UnitConversionList from '../ManageProduct/UnitConversionList/UnitConversionList';
import { AddUnitCostContent } from '../ManageProduct/AddUnitCost/AddUnitCost';

// import StatusBadgeCommon from '../Badge/StatusBadgeCommon';
const { Text } = Typography;

const ModalConfirm: React.FC<ModalConfirmProps> = ({
  open,
  onConfirm,
  setOpen,
  isLoading = false,
  imageMain,
  isDetail = false,
  checkInactive,
  statusSave = '',
  setInactive,
  form,
  productAttributes,
  productUnits,
  productSalePrices,
  onCancel,
  headerLabel,
  headerContent,
  saveButtonLabel,
  suppliers,
  brand,
  category,
  units,
  categoryName,
  brandName,
  currencyUnitName,
  baseUnitName,
  // statusToCopy,
}) => {
  const getUnitName = (unitId: string | number) => units?.find((unit) => unit.id === unitId)?.name || '';
  return (
    <Modal
      centered
      open={open}
      className='md:w-[600px] md:min-w-[700px] lg:min-w-[1000px] xl:min-w-[1255px] modal-none-padding'
      closable={false}
      footer={null}
      maskClosable={false}
    >
      <HeaderContent
        size='sm'
        key='confirm-create-product'
        label={
          headerLabel ||
          `${checkInactive ? 'Xác nhận ngừng kinh doanh sản phẩm' : `XÁC NHẬN ${isDetail ? 'Cập nhập Sản Phẩm' : 'Tạo Sản Phẩm Mới'} - ${statusSave}`}`
        }
        contentHeader={
          headerContent ||
          `Vui lòng kiểm tra lại các thông tin của sản phẩm ${checkInactive ? `trước khi ngừng kinh doanh sản phẩm` : `${isDetail ? `trước khi hoàn tất việc cập nhập sản phẩm` : `trước khi hoàn tất việc tạo mới sản phẩm`}`}`
        }
      />

      <div className='px-6 py-3 bg-[var(--bgGreyColor)] rounded-lg'>
        <div className='flex-1 flex flex-col gap-1 p-4 max-h-[calc(100vh-240px)] overflow-y-auto rounded-lg '>
          <div className='px-6 mt-3 bg-white relative rounded-lg'>
            <h2 className='text-base font-bold  pt-2'>Thông tin cơ bản</h2>
            <div className='ml-6 flex flex-col gap-3 mt-3'>
              <div className='grid grid-cols-4 gap-6 py-[6px]'>
                <Info label='Mã:' value={form.getFieldValue('code')} />
                <Info
                  className='col-span-2'
                  label='Tên:'
                  value={[form.getFieldValue('name'), form.getFieldValue('color'), form.getFieldValue('dimension')]
                    .filter((item) => item !== undefined && item !== null && item !== '')
                    .join(' - ')}
                />
                {/* {statusToCopy &&
                (statusToCopy === 'Active' ? (
                  <StatusBadgeCommon
                    label='Đang hoạt động'
                    bgColorClass='bg-[var(--sematicSuccessColor500)]'
                    textColorClass='text-white'
                  />
                ) : statusToCopy === 'Inactive' ? (
                  <StatusBadgeCommon label='Ngừng kinh doanh' bgColorClass='bg-red-500' textColorClass=' text-white' />
                ) : (
                  <StatusBadgeCommon
                    label='Bản nháp'
                    bgColorClass='bg-[var(--textBlack24)]'
                    textColorClass='text-[var(--textBlack)]'
                  />
                ))} */}
              </div>
              <div className='grid grid-cols-4 gap-6 py-[6px]'>
                <Info
                  label='Nhà cung cấp:'
                  value={suppliers?.map((supplier) => supplier.baseUser.name).join(' - ') || '---'}
                />
                <Info label='Danh mục:' value={category?.name || categoryName || '---'} />
                <Info label='Thương hiệu:' value={brand?.name || brandName || '---'} />
              </div>
              {/* Dòng 3 */}
              <div className='grid grid-cols-4 gap-6 py-[6px]'>
                <Info label='Màu sắc:' value={form.getFieldValue('color') || '---'} />
                <Info label='Quy cách:' value={form.getFieldValue('dimension') || '---'} />
                <Info label='Dộ dày:' value={form.getFieldValue('sizeSpec') || '---'} />
              </div>
              <div className='grid grid-cols-4 gap-6 py-[6px]'>
                <Info
                  label='Nhập vào:'
                  value={
                    `${formatCurrency(form.getFieldValue('costPrice')) || ''} ${getUnitName(form.getFieldValue('currencyUnitId')) || currencyUnitName || ''}/` +
                    (getUnitName(form.getFieldValue('baseUnitId')) || baseUnitName || '')
                  }
                />
                <Info
                  className='col-span-2'
                  label='Mô tả sản phẩm:'
                  value={form.getFieldValue('describeProduct') || '---'}
                />
              </div>
            </div>
            <div className='absolute right-[42px] bottom-[17px]'>
              {imageMain ? (
                <>
                  <img
                    alt='Ảnh sản phẩm'
                    src={`${getFilePath()}/${imageMain}`}
                    className='w-[164px] h-[164px] object-cover'
                  />
                </>
              ) : (
                <>
                  <img src={imageEmpty} alt='Ảnh trống' className='w-[164px] h-[164px]' />
                </>
              )}
            </div>
          </div>
          {productAttributes && productAttributes.length > 0 && (
            <div className='px-6 py-3 mt-3 bg-white rounded-lg'>
              <h2 className='text-base font-bold'>Thuộc tính sản phẩm</h2>
              <div className='ml-6'>
                {productAttributes?.map((attr: Attribute) => (
                  <ManageAttribute
                    key={attr.order}
                    title={attr.title || ''}
                    isEdits={false}
                    type='attribute'
                    surcharge={attr.salePrice || 0}
                    note={attr.note}
                    order={attr.order}
                    className='bg-[var(--bgBlackOpacity5)] p-[11px] pl-2 pr-3 rounded-lg mt-3'
                  />
                ))}
              </div>
            </div>
          )}
          {productSalePrices && productSalePrices.length > 0 && (
            <div className='px-6 py-3 mt-3 bg-white rounded-lg'>
              <h2 className='text-base font-bold mb-2'>Định mức giá sỉ/lẻ</h2>
              <div className='ml-6 mt-2'>
                <AddUnitCostContent productSalePrices={productSalePrices} isEdits={false} />
              </div>
            </div>
          )}
          {productUnits && productUnits.length > 0 && (
            <div className='px-6 py-3 mt-3 bg-white rounded-lg'>
              <h2 className='text-base font-bold'>Đơn vị tính</h2>
              <div className='ml-6'>
                <UnitConversionList
                  productUnits={productUnits.filter((unit) => unit.checked === true)}
                  isEdit={false}
                  isView={true}
                />
              </div>
            </div>
          )}
        </div>
        <div className='flex justify-center gap-6 mt-4'>
          <ButtonCommon
            color='barcode'
            className='text-black'
            radius='rounded'
            size='xs'
            onClick={() => {
              onCancel(setOpen);
              if (setInactive) {
                setInactive(false);
              }
            }}
          >
            Hủy
          </ButtonCommon>
          <ButtonCommon
            color='basic'
            className='bg-[var(--primaryColor500)] px-3 gap-2'
            loading={isLoading}
            radius='rounded'
            onClick={onConfirm}
          >
            {saveButtonLabel || `${checkInactive ? `Xác nhận ngừng kinh doanh` : `Lưu ${statusSave}`}`}
          </ButtonCommon>
        </div>
      </div>
    </Modal>
  );
};

const Info = ({ label, value, className = '' }: { label: string; value: string; className?: string }) => (
  <div className={'flex gap-3 ' + className}>
    <Text className='whitespace-nowrap text-sm text-[var(--textBlack56)]'>{label}</Text>
    <Text className='text-sm'>{value}</Text>
  </div>
);

export default ModalConfirm;
